export default "__VITE_ASSET__CWYIB72s__"